module.exports = __webpack_public_path__ + "static/media/THA.67bf26cd.svg";